export const AVAILABLE_COLOURS = [
    '#f2647a', '#eb9e5a', '#53c7ab',
    '#4955bf', '#8043d7'
];

export const COOKIE_NAME = `pcdcoimbra2022_timer`;
export const COOKIES_FADE_TIMEOUT = 500;